import { Outlet } from "react-router-dom"

const ExternalLayout = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default ExternalLayout;